import { ResampleSize } from './reformatValidation';

export interface OutputVolumeEstimate {
    /** Human-readable dimensions string, e.g. "512 × 512 × 42". */
    dimensions: string;
    /** Number of output slices. */
    sliceCount: number;
    /** Estimated size in megabytes (formatted to 1 decimal). */
    megabytes: string;
}

/**
 * Estimate the output volume dimensions and memory footprint
 * for a given resample configuration (Int16 pixels = 2 bytes/voxel).
 *
 * Returns null if the slice thickness is invalid.
 */
export function estimateOutputVolume(
    resampleSize: ResampleSize,
    sliceThicknessMm: number,
    zRange: [number, number]
): OutputVolumeEstimate | null {
    if (isNaN(sliceThicknessMm) || sliceThicknessMm <= 0) {
        return null;
    }
    const zExtent = zRange[1] - zRange[0];
    const nz = Math.max(1, Math.ceil(zExtent / sliceThicknessMm));
    const totalVoxels = resampleSize * resampleSize * nz;
    const megabytes = (totalVoxels * 2) / (1024 * 1024);
    return {
        dimensions: `${resampleSize} × ${resampleSize} × ${nz}`,
        sliceCount: nz,
        megabytes: megabytes.toFixed(1),
    };
}
